import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header/Header";
import Footer from "../components/Footer";

function Terms_Conditions() {
  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <div className="legal-page" style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem", lineHeight: "1.8" }}>
          <h1>Terms and Conditions</h1>
          <p><em>Last updated: August 2026</em></p>

          <p>Please read these Terms and Conditions carefully before using our website and services.</p>

          <h2>1. Bookings and Reservations</h2>
          <ul>
            <li>All bookings are subject to availability.</li>
            <li>A confirmation code will be provided upon successful booking. You must retain this code for managing your reservation.</li>
          </ul>

          <h2>2. User Accounts</h2>
          <ul>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>You must provide accurate and complete information when creating an account.</li>
            <li>We reserve the right to suspend or terminate accounts that violate these terms.</li>
          </ul>

          <h2>3. Cancellation</h2>
          <ul>
            <li>Bookings can be cancelled through your account or using your confirmation code.</li>
            <li>Cancellation policies and any applicable fees should be confirmed at the time of booking.</li>
          </ul>

          <h2>4. Limitation of Liability</h2>
          <p>We shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services.</p>

          <h2>5. Modifications</h2>
          <p>We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting.</p>

          <h2>6. Governing Law</h2>
          <p>These terms shall be governed by the laws of the Federal Republic of Nigeria.</p>

          <h2>7. Contact</h2>
          <p>Email: support@tayandtoscorporations.com<br />Phone: +234 814 074 9365</p>

          <p style={{ marginTop: "2rem", fontSize: "0.9rem", color: "#666" }}>
            <em>These terms are provided as a template and should be reviewed by a qualified legal professional.</em>
          </p>

          <Link to="/" style={{ display: "inline-block", marginTop: "1rem", color: "#F15A29" }}>&larr; Back to Home</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Terms_Conditions;
